// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__gidiX","cell":"ColumnAccessor_cell__3CANB","firstCellAccent":"ColumnAccessor_firstCellAccent__2Bd29"};